<template>
  <div class="my-footer">
    <!-- <div class="w70">
      <div>
        <div style="font-size: 22px;font-weight: 700;color: rgba(255, 255, 255, 1);">关于我们</div>
        <div style="width: 400px;font-size: 14px;line-height: 25px;color: rgba(255, 255, 255, 0.6);margin-top: 10px;text-align: justify;">
          创投集团成立于2019年7月，2023年7月纳入市管重点企业管理，注册资本10亿元，是全市第一家获得双AA+评级的企业。2023年集团及代管公司资产总额868.4亿元。集团及代管公司现有员工216人，党员74人，6个支部。内设党群工作部、综合管理部、财务中心、融资中心、战略发展部、资产管理部、工程管理部、风控合规部、纪检监察室9个部门。
        </div>
      </div>
      <div>
        <div style="font-size: 22px;font-weight: 700;color: rgba(255, 255, 255, 1);">关注我们</div>
        <div style="margin-top: 20px;"><img src="./../static/px-erweima.png" alt="" style="width: 100px;"></div>
        <div style="font-size: 14px;line-height: 25px;color: rgba(255, 255, 255, 0.6);margin-top: 5px;text-align: center;">
          微信公众号</div>
      </div>
      <div>
        <div style="font-size: 22px;font-weight: 700;color: rgba(255, 255, 255, 1);">联系我们</div>
        <div style="font-size: 14px;line-height: 25px;color: rgba(255, 255, 255, 0.6);margin-top: 10px;">
          <div>地址： 江西省萍乡市萍乡经济技术开发区观丰路113号</div>
          <div>电话： (+86)0799-6658636</div>
        </div>
      </div>
    </div> -->
    <div class="w70" style="font-size:14px;color: rgba(255, 255, 255,1);flex-direction: column;align-items: center;line-height: 24px;">
      <div>Copyright © 2024 All Rights Reserved　萍乡创新发展投资集团有限公司</div>
      <div style="display: flex;">地址： 江西省萍乡市萍乡经济技术开发区金融港2号楼　<img src="./../static/ba.png" height="20"/>&nbsp;<a href="https://beian.mps.gov.cn/#/query/webSearch?code=36030102000115" rel="noreferrer" target="_blank" style="cursor: pointer;color: rgb(255, 255, 255);text-decoration: none;">赣公网安备 36030102000115号</a>
      &nbsp;&nbsp;&nbsp;&nbsp;<a href="http://beian.miit.gov.cn" rel="noreferrer" target="_blank" style="cursor: pointer;color: rgb(255, 255, 255);text-decoration: none;">赣ICP备2021009348号</a></div>
      <div>技术支持：广东中建普联科技股份有限公司</div>
    </div>
  </div>
</template>
<script setup></script>
<style scoped>
.my-footer {
  width: 100%;
  margin-top: 30px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(
      90deg,
      rgba(219, 36, 28, 1) 0%,
      rgba(235, 132, 39, 1) 100%
    ),
    rgba(0, 117, 194, 1);
}
.w70 {
  width: 1300px;
  display: flex;
  justify-content: space-between;
  padding: 35px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}
</style>